export type ComplianceType =
    | ComplianceTypes.BACKGROUND_CHECK
    | ComplianceTypes.LEGAL_DOCS
    | ComplianceTypes.WORKFORCE_CLASSIFICATION;

export enum ComplianceTypes {
    BACKGROUND_CHECK = 'background_check',
    LEGAL_DOCS = 'legal_docs',
    WORKFORCE_CLASSIFICATION = 'classification',
}

export enum Answers {
    YES = 'yes',
    NO = 'no',
}

export type Answer = Answers.YES | Answers.NO;

export enum ClassificationQuestionIds {
    DIRECTLY_MANAGE = 'directly_manage',
    SAME_ASSIGNMENT_REQUIRES = 'same_assignment_requires',
    SUBSTITUTE_ANOTHER = 'substitute_another',
    WORK_RESTRICTED = 'work_restricted',
}

export interface QuestionsSubmitData {
    [ket: string]: {
        answer: Answer;
        question: string;
    };
}

export interface ClassificationForm {
    [ClassificationQuestionIds.DIRECTLY_MANAGE]: Answer;
    [ClassificationQuestionIds.SAME_ASSIGNMENT_REQUIRES]: Answer;
    [ClassificationQuestionIds.SUBSTITUTE_ANOTHER]: Answer;
    [ClassificationQuestionIds.WORK_RESTRICTED]: Answer;
}

export enum PaymentMethod {
    PURCHASE = 'purchase',
    CREDIT = 'credit',
}

export const COPIES_PREFIX = 'compliance.modal';

export interface BackgroundCheckPackageData {
    typeId: string;
    packageItemsIds?: string[];
    timeEstimation: {
        min: number;
        max: number;
        amount: string;
    };
    discountInPercents?: number;
    monthlyCredit?: { value: number };
    price: number;
    currency: string;
}

export interface WorkforceClassificationPackageData {
    typeId: string;
    timeEstimation: {
        min: number;
        max: number;
        amount: string;
    };
    monthlyCredit: { value: number };
    price: number;
    currency: string;
}

export interface BackgroundCheckData {
    canRequestBackgroundCheck: boolean;
    canDownloadBackgroundCheckFile: boolean;
    backgroundCheckPackageData: BackgroundCheckPackageData;
    isEligibleForBackgroundCheck: boolean;
}

export interface WorkforceClassificationData {
    canRequestWorkforceClassification: boolean;
    canDownloadWorkforceClassificationFile: boolean;
    workforceClassificationPackageData: WorkforceClassificationPackageData;
}

export interface ComplianceData {
    backgroundCheckData: BackgroundCheckData;
    legalDocsData: unknown;
    workorceClassificationData: WorkforceClassificationData;
}
